import React from 'react';
import { useSignUpContext, SignUpStage } from './SignUpContext';
import ProFormaQuickStart from '../ProFormaQuickStart/ProFormaQuickStart';
import BOEEstimate from '../BOEEstimate/BOEEstimate';
import ProFormaDashboard from '../ProFormaDashboard/ProFormaDashboard';

export const SignUp: React.FC = () => {
    const { currentStage, setCurrentStage } = useSignUpContext();

    switch (currentStage) {
        case SignUpStage.PRO_FORMA_QUICK_START:
            return <ProFormaQuickStart />;
        case SignUpStage.PRO_FORMA_DASHBOARD:
            return <ProFormaDashboard />;
        case SignUpStage.BOE_CALCULATOR:
            return <BOEEstimate />;
        default:
            setCurrentStage(SignUpStage.BOE_CALCULATOR);
            return <BOEEstimate />;
    }
};

export default SignUp;
